export function isRefundable(txn) {
  if (!txn) return false;
  if (txn.status !== "completed") return false;
  if (!["debit", "manual_debit"].includes(txn.type)) return false;
  const refunds = txn.refunds || [];
  return !refunds.some((r) => r.status === "completed");
}
